<template>
  <div
    v-if="$login.can('channels.create')"
    class="channels-create"
  >
    <page-header header="Create Channel">
      <router-link
        v-if="channel"
        :to="{ name: 'channels.users', params: { channelId: channel.id } }"
        class="ml-1 btn btn-outline-secondary "
      >
        <icon
          icon="users"
          class="mr-1"
        />
        Analysts
      </router-link>
    </page-header>

    <channel-form
      class="mt-3"
      ref="form"
      @save-success="saveSuccess"
    />
  </div>
</template>

<script>
import ChannelForm from './Form'
import {successNotification} from '@/notifications'

export default {
  components: {
    ChannelForm,
  },
  metaInfo () {
    return {
      title: 'Create Channel',
    }
  },
  data () {
    return {
      channel: null,
      addressShowRemove: [],
      loading: false,
      tickerShowRemove: [],
      editUser: null,
    }
  },
  methods: {
    saveSuccess () {
      this.$notify(successNotification('Created successfully!'))
      this.$router.replace({name: 'channels'})
    },

    setData (err, channel) {
      if (!err) {
        this.channel = channel.data
      }
    },
  },
}
</script>
